module.exports = __webpack_public_path__ + "img/auth0.b880207a.png";